/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Tasks_Col_Status_Completed_OnInputs */

const en_tasks_col_status_completed_on = /** @type {(inputs: Tasks_Col_Status_Completed_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`On ${i?.date}`)
};

const pt_br2_tasks_col_status_completed_on = /** @type {(inputs: Tasks_Col_Status_Completed_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "On {date}" |
*
* @param {Tasks_Col_Status_Completed_OnInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const tasks_col_status_completed_on = /** @type {((inputs: Tasks_Col_Status_Completed_OnInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Col_Status_Completed_OnInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_col_status_completed_on(inputs)
	return pt_br2_tasks_col_status_completed_on(inputs)
});